import { styled, css } from "styled-components";

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const FooterContentWrapper = styled.div`
  background: ${({ theme }) => theme.colors.default[50]};
  width: 100%;
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -1px;
`;

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 24px 24px 24px;
  height: 100%;
  align-items: center;
  width: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  width: 100%;
  ${({ theme }) => css`
    ${theme.breakpoints.sm.query} {
      flex-direction: column;
    }
  `}
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.default[600]};
  font-weight: 600;
  max-width: 175px;
`;
